// extracted by mini-css-extract-plugin
module.exports = {"themeProvider":"accessibilityThemeProvider_themeProvider__2eX6L","value":"accessibilityThemeProvider_value__2NcMj","image":"accessibilityThemeProvider_image__H9uSF"};